<template>
  <div style="height: 100vh;">
    <slot/>
  </div>
</template>

<script>
export default {}
</script>

<style>
body {
    margin: 0;
}
</style>
